import { HostMemory } from '@ftr/contracts/regional-api'
import { AbstractClassBuilder } from '@ftr/foundation'

export class HostMemoryBuilder extends AbstractClassBuilder<HostMemory> {
  constructor() {
    super(HostMemory, {
      bytes: 3.2e10,
    })
  }
}
